import api from './api';

const cache = new Map();
const retryAfter = new Map();
const MAX_CACHE_SIZE = 200;
const RETRY_DELAY = 60 * 1000;

export async function resolveTermLinks(text) {
  if (typeof text !== 'string' || text.trim().length < 8) return [];
  const normalized = text.trim().slice(0, 6000);
  const cached = cache.get(normalized);
  if (cached) return cached;

  const blockedUntil = retryAfter.get(normalized) || 0;
  if (blockedUntil > Date.now()) {
    throw new Error('Contextual term lookup is temporarily unavailable.');
  }

  let request;
  request = api.post('/public/term-links', { text: normalized })
    .then(({ data }) => {
      if (!data?.success || !Array.isArray(data.terms)) {
        throw new Error('Term-link service returned an invalid response.');
      }
      const terms = data.terms.filter(term => {
        if (typeof term?.text !== 'string' || typeof term?.url !== 'string') return false;
        try {
          const url = new URL(term.url);
          return url.protocol === 'https:' && url.hostname === 'www.google.com'
            && url.pathname === '/search' && normalized.toLowerCase().includes(term.text.toLowerCase());
        } catch {
          return false;
        }
      });
      cache.set(normalized, terms);
      return terms;
    })
    .catch(error => {
      retryAfter.set(normalized, Date.now() + RETRY_DELAY);
      throw error;
    })
    .finally(() => {
      if (cache.get(normalized) === request) cache.delete(normalized);
    });

  cache.set(normalized, request);
  if (cache.size > MAX_CACHE_SIZE) cache.delete(cache.keys().next().value);
  return request;
}
